import { Colors } from '../consts/Colors';
import RoundedButton2 from './RoundedButton2';
import Label from './Label';
import { LabelData } from '../consts/LabelData';
import DragManager from './DragManager';

// Création du deck de jeu pour la partie 2

export default class Deck2 extends Phaser.GameObjects.Container {
    constructor(scene, x, y) {
        super(scene, x, y, []);
        scene.add.existing(this);

        this.scene = scene;
        this.rect = this.scene.add.rexRoundRectangle(0, 0, 560, 308, 26, Colors.Elmt.Beige).setOrigin(0.5);
        this.rect.setStrokeStyle(2, Colors.Elmt.White, 1);
        this.add(this.rect);
        this.isFirstDrop = true
        this.placeholders = [];
        for (let i = 0; i < LabelData.length; i++) {
            const el = LabelData[i];
            this.ph = this.scene.add.image(0, el.labelY, 'labelPlaceholder').setOrigin(0.5);
            this.add(this.ph);
            this.placeholders.push(this.ph);
        }

        this.validBtn = new RoundedButton2(this.scene, 0, 113, 154, "Valider");
        this.add(this.validBtn);
        this.validBtn.setLocked()

        this.validBtn.setClickFunction(() => {
            this.checkAnswer()
        })

        this.labels = [];
        this.dragManager = new DragManager(this.scene);
        for (let i = 0; i < LabelData.length; i++) {
            const el = LabelData[i];
            this.label = new Label(this.scene, 0, el.labelY, el, this);
            this.add(this.label);
            this.labels.push(this.label);
            this.dragManager.addDraggable(this.label);
        }
    }

    setDeckAction(cardData) {

    }
    setDeckTrue() {
        this.repLogo = this.scene.add.image(-93, -74, 'goodAnswer').setOrigin(0.5)
        this.add(this.repLogo)
        this.repText = this.scene.add.text(-59, -86, "BRAVO", {
            font: "40px MassiliaBold",
            color: Colors.Text.Green
        }).setOrigin(0)
        this.add(this.repText)
        this.repContent = this.scene.add.text(0, -40, "Vous avez complété le schéma des Soldes Intermédiaires de Gestion (SIG)!", {
            font: "22px MassiliaRegular",
            color: Colors.Text.Blue,
            align: "left",
            wordWrap: { width: 380, useAdvancedWrap: true }
        }).setOrigin(0.5, 0)
        this.add(this.repContent)
        this.nextBtn = new RoundedButton2(this.scene, 0, 82, 310, "Découvrir votre score");
        this.add(this.nextBtn);
        this.nextBtn.setClickFunction(() => {
            this.scene.launchEndBoard()
        })
    }
    setDeckFalse(score) {
        let content
        if (score == 2) {
            content = "1 MAUVAISE RÉPONSE"
        } else if (score == 1) {
            content = "2 MAUVAISES RÉPONSES"
        } else if (score == 0) {
            content = "3 MAUVAISES RÉPONSES"
        }
        this.repLogo = this.scene.add.image(0, -56, 'badAnswer').setOrigin(0.5)
        this.add(this.repLogo)
        this.repText = this.scene.add.text(0, -5, content, {
            font: "40px MassiliaBold",
            color: Colors.Text.Red
        }).setOrigin(0.5, 0)
        this.add(this.repText)
        this.nextBtn = new RoundedButton2(this.scene, 0, 113, 188, "Réessayer");
        this.add(this.nextBtn);
        this.nextBtn.setClickFunction(() => {
            this.labels.forEach(label => {
                if (label.isCorrect === false) {
                    label.reset()
                    this.nextBtn.destroy()
                    this.placeholders.forEach(ph => { ph.setAlpha(1) })
                    this.validBtn.setAlpha(1)
                    this.repLogo.destroy()
                    this.repText.destroy()
                }
            })
        })
    }

    checkAnswer() {
        this.result = 0
        this.labels.forEach(label => {
            if (label.zoneDroped.zoneId === label.zoneId) {
                if (this.isFirstDrop === true) {
                    this.scene.score.bravo++
                }
                label.setGood()
                label.isCorrect = true
                this.result++
            } else {
                label.isCorrect = false
                if (this.isFirstDrop === true) {
                    this.scene.score.mauvais++
                }
                label.setBad()
            }
        })
        this.isFirstDrop = false
        this.placeholders.forEach(ph => { ph.setAlpha(0) })
        this.validBtn.setAlpha(0)
        if (this.result == 3) {
            this.scene.launchEndBoard()
        } else {
            this.setDeckFalse(this.result)
        }
    }
}